import 'es6-promise/auto'
import Vue from 'vue'
import Vuex from 'vuex'
import App from './App.vue'
import VueRouter from 'vue-router'
import VueCurrencyInput from 'vue-currency-input'
import VueCurrencyFilter from 'vue-currency-filter'
import jQuery from 'jquery'
import moment from 'moment'
import routerConfig from '@config/router'
import env from '@config/environment'
import Api from '@app/service/Api'
import '@fortawesome/fontawesome-free/css/all.css'
import 'ionicons/dist/css/ionicons.css'
import 'icheck-bootstrap'
import 'admin-lte/dist/css/adminlte.min.css'
import 'jquery-ui'
import 'bootstrap/dist/js/bootstrap.bundle.js'
import 'chart.js'
import 'daterangepicker/daterangepicker.css'
import 'daterangepicker/daterangepicker.js'
import 'tempusdominus-bootstrap-4/build/css/tempusdominus-bootstrap-4.css'
import 'tempusdominus-bootstrap-4/build/js/tempusdominus-bootstrap-4.js'
import 'overlayscrollbars/css/OverlayScrollbars.css'
import 'overlayscrollbars/js/jquery.overlayScrollbars.js'
import 'admin-lte/dist/js/adminlte.js'
import '@assets/css/style.css'
import '@assets/css/loader.css'
import 'bootstrap-select/dist/css/bootstrap-select.css'
import 'bootstrap-select/dist/js/bootstrap-select.js'
import 'admin-lte/plugins/pace-progress/pace.min.js'
import 'admin-lte/plugins/jquery-validation/jquery.validate.min.js'
import 'admin-lte/plugins/jquery-validation/additional-methods.min.js'
import Select2 from "@app/components/Select2"
import "select2/dist/css/select2.css"
import "select2/dist/js/select2.full.js"
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

import "@assets/scss/custom.scss"

const currencyOptions = {
    globalOptions: {
        currency: 'IDR',
        locale: 'id'
    }
}

Vue.use(Vuex)
Vue.use(VueRouter)
Vue.use(VueCurrencyInput, currencyOptions)

const filterCurrencyOptions = {
  symbol : "Rp",
  thousandsSeparator: ".",
  fractionCount: "2",
  fractionSeparator: ",",
  symbolPosition: 'front',
  symbolSpacing: true
}
Vue.use(VueCurrencyFilter, filterCurrencyOptions)
Vue.component("select2", Select2)
Vue.use(Toast, {
    transition: "Vue-Toastification__bounce",
    maxToasts: 5,
    newestOnTop: true
  });

const store = new Vuex.Store({
    state: {
        user: {},
        user_image: null,
        data: {},
        title: null,
        subtitle: null,
        loading: false
    },
})

const router = new VueRouter(routerConfig)
moment.locale('id')

Vue.config.productionTip = false
Vue.prototype.$ = window.$ = window.jQuery = jQuery
Vue.prototype.moment = window.moment = moment
Vue.prototype.env = window.env = env
window.adminlte = adminlte
Vue.prototype.Api = window.Api = new Api(env, router,
    ['login', 'forgot_password', 'reaktivasi_akun', 'success_sent_email', 'success_change_password'])
Vue.prototype.currencyOptions = currencyOptions.globalOptions
window.Api.setStore(store)

window.Vue = Vue

new Vue({
  router: router,
  store: store,
  render: h => h(App)
}).$mount('#app')
